/** All Errors related to the login screen wise */
export const LOGIN_ERROR = {
        IDAM_SCLN0006: "Please enter valid credentials to proceed.",
        IDAM_TEJVF0002:  "Please enter valid credentials to proceed.",
        IDAM_BOTH_BLANK: "Please enter your Jio ID and password.",
        IDAM_JIOID_BLANK: "Please enter your Jio ID.",
        IDAM_PASS_BLANK: "Please enter your password.",

        OTP_SCLN0006 :"Entered OTP is invalid/expired.",//InvalidOTPLogin
        OTP_SCLN0110 :"Please use a registered JIO number.",//MobileNotRegistered
        OTP_SCLN0111: "You have made too many OTP requests. Please try after sometime",
        OTP_SCLN0301 :"You have exceeded the maximum number of attempts to enter the OTP.Please try after sometime.",//MaxAttemptReached,
        OTP_SCLN0310:"Email doesn't exist. Please enter a verified/registered email.",
        OTP_SCLN0179:"Your account has been disabled. Kindly contact your enterprise admin for more details.",
        OTP_SCLN0183:"This mobile number is not registered.",
        OTP_SCLN0010:"Account doesn't exist for this mobile number",
        OTP_SCLN0311: "Multiple Records found. Contact Customer Support.",
        OTP_Invalid_Mobile_Length : "Please enter a 10 digit mobile no.",
        OTP_Invalid_Mobile_Format : "Please enter a valid mobile no.",
        OTP_Enter_OTP_Check : "Please enter the OTP to proceed.",
        OTP_Invalid_OTP_Length:"Please enter a 6 digit OTP number.",
        OTP_Invalid_OTP_Format:"Please enter a valid OTP number.",
        OTP_Unverified_OTP_Error: "OTP cannot be send due to many unverified OTP requests.Please try after sometime.",
        ICLOUD_2FA_CODE_LENGTH: 'Please enter a 6 digit code.',
        

        UseOtherLoginOption: "Something went wrong.Please use other login options or refresh your browser.",
        TEJVF0002: "Invalid Request.",
        SCLN0058: "Invalid Device Key.",
        SCLN0305:"Invalid QR Code.",
        SCLN0018:"Database Error.",
        SCLN0013:"Invalid DataFormat in Request.",
        SCLN0306: "QR Code not found",
        SCLN0307:"QR Not Validated Yet",
        SCLN0308:"QR Code already Used for Login",

        JIOID_ERROR:"We are facing some issues logging you in with JioId. Please try again after some time",

        Invalid_Passphrase: "Incorrect passphrase",

        Genric_Passphrase_Error:"We are facing some issues to validate passphrase. Please try again after some time",

        BannerApiError : "Something went wrong. Please try again later!",

        genericError : "Something went wrong. Please try again later!",
        SOCIAL_ERROR:"We are facing some issues logging you in with Social. Please try again after some time",

       
}


